// When a sticky product info column is taller than the screen, stick it by its bottom edge so every block stays
// reachable. The column can be re-rendered (variant changes swap its HTML), so new columns are picked up as they appear.
(() => {
  const GAP = 20;
  const watched = new WeakSet();

  const setTop = (column) => {
    column.style.setProperty('--sticky-info-top', `${Math.min(GAP, window.innerHeight - column.offsetHeight - GAP)}px`);
  };

  const resizeObserver = new ResizeObserver((entries) => entries.forEach((entry) => setTop(entry.target)));

  const watchColumns = () => {
    document.querySelectorAll('.product__column-sticky').forEach((column) => {
      if (watched.has(column)) return;
      watched.add(column);
      setTop(column);
      resizeObserver.observe(column);
    });
  };

  watchColumns();
  new MutationObserver(watchColumns).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', () => document.querySelectorAll('.product__column-sticky').forEach(setTop));
})();
